<template>
  <v-layout row justify-center>
    <v-dialog v-model="show" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="onClickCloseModal()">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ toolbarTitle }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
              class="pa-3"
              style="border-radius: 25px; height: auto;"
              color="secondary"
              @click="onClickSaveContact()"
            >
              <v-icon class="black--text mr-2">
                mdi-check
              </v-icon>
              <span class="black--text">GUARDAR</span>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-layout align-center justify-center row fill-height>
          <v-flex xs12 md4>
            <v-card flat>
              <v-card-text>
                <v-form ref="contactForm">
                  <v-layout align-center justify-center column fill-height>
                    <v-flex xs12 class="mt-5">
                      <h2>
                        Información fiscal
                      </h2>
                    </v-flex>
                    <v-flex xs12>
                      <v-layout align-center justify-center column fill-height>
                        <v-flex xs12>
                          <v-layout row wrap>
                            <v-flex xs12 class="pa-3">
                              <v-text-field
                                ref="name"
                                v-model="contactForm.name"
                                :rules="[rules.required]"
                                label="Nombre fiscal o empresa"
                                required
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 md6 class="pa-3">
                              <v-text-field
                                ref="cif"
                                v-model="contactForm.cif"
                                :rules="[rules.required]"
                                label="NIF/CIF"
                                required
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 md6 class="pa-3">
                              <v-text-field
                                ref="address"
                                v-model="contactForm.address"
                                :rules="[rules.required]"
                                label="Dirección"
                                required
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 md6 class="pa-3">
                              <v-text-field
                                ref="city"
                                v-model="contactForm.city"
                                :rules="[rules.required]"
                                label="Ciudad"
                                required
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 md6 class="pa-3">
                              <v-text-field
                                ref="postal_code"
                                v-model="contactForm.postal_code"
                                :rules="[rules.required]"
                                label="Código postal"
                                required
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 md6 class="pa-3">
                              <v-text-field
                                ref="province"
                                v-model="contactForm.province"
                                :rules="[rules.required]"
                                label="Provincia"
                                required
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 md6 class="pa-3">
                              <v-text-field
                                ref="country"
                                v-model="contactForm.country"
                                :rules="[rules.required]"
                                label="País"
                                required
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 class="mt-5">
                      <h2>
                        Datos de contacto
                      </h2>
                    </v-flex>
                    <v-flex xs12>
                      <v-layout align-center justify-center column fill-height>
                        <v-flex xs12>
                          <v-layout row wrap>
                            <v-flex xs12 class="pa-3">
                              <v-text-field
                                ref="contact_name"
                                v-model="contactForm.contact_name"
                                :rules="[]"
                                label="Nombre y apellidos"
                                required
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 md6 class="pa-3">
                              <v-text-field
                                ref="contact_email"
                                v-model="contactForm.contact_email"
                                :rules="[]"
                                label="Email"
                                required
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 md6 class="pa-3">
                              <v-text-field
                                ref="contact_email2"
                                v-model="contactForm.contact_email2"
                                :rules="[]"
                                label="Email 2"
                                required
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 md6 class="pa-3">
                              <v-text-field
                                ref="contact_phone"
                                v-model="contactForm.contact_phone"
                                :rules="[]"
                                label="Teléfono"
                                required
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12 md6 class="pa-3">
                              <v-text-field
                                ref="contact_phone2"
                                v-model="contactForm.contact_phone2"
                                :rules="[]"
                                label="Teléfono 2"
                                required
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import apiCtrl from '@/services/api/abstract/abstract-api';

export default {
  name: 'OpenBillingContactForm',
  components: {},
  props: ['showModal', 'contactId'],
  data() {
    return {
      tabs: ['Datos'],
      selectedTab: 0,
      rules: {
        required: value => !!value || 'Este campo es obligatorio.',
        counter: value => value.length <= 20 || 'Max 20 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || 'Email inválido';
        },
      },
      contactForm: {
        id: null,
        clavedat: null,
        openbilling_profile_id: null,
        name: null,
        cif: null,
        address: null,
        city: null,
        postal_code: null,
        province: null,
        country: null,
        type: null,
        contact_name: null,
        contact_email: null,
        contact_email2: null,
        contact_phone: null,
        contact_phone2: null,
      },
    };
  },
  mounted() {},
  computed: {
    show() {
      return this.showModal;
    },
    toolbarTitle() {
      return this.contactId ? 'EDITAR CONTACTO' : 'NUEVO CONTACTO';
    },
    billingProfileId() {
      return this.$store.getters.currentOpenbillingProfileId;
    },
    clavedat() {
      return this.$store.state.clavedat;
    },
  },
  methods: {
    createContact() {
      Object.keys(this.contactForm).forEach(f => {
        console.log(f);
        if (this.$refs[f]) {
          this.$refs[f].validate(true);
        }
      });

      this.contactForm.clavedat = this.clavedat;
      this.contactForm.openbilling_profile_id = this.billingProfileId;

      apiCtrl
        .post(`/openbilling/${this.clavedat}/contacts/create`, this.contactForm)
        .then(res => {
          this.$emit('on-saved-contact', res.data.data);
        })
        .catch(err => console.log(err));
    },
    updateContact() {
      this.contactForm.clavedat = this.clavedat;
      this.contactForm.openbilling_profile_id = this.billingProfileId;

      apiCtrl
        .post(`/openbilling/${this.clavedat}/contacts/update/${this.contactId}`, this.contactForm)
        .then(res => {
          this.$emit('on-saved-contact', res.data.data);
        })
        .catch(err => console.log(err));
    },
    onClickSaveContact() {
      if (this.contactId) {
        this.updateContact();
      } else {
        this.createContact();
      }
    },
    onClickCloseModal() {
      this.$emit('click-on-close');
    },
    getContactData() {
      apiCtrl
        .get(`/openbilling/${this.clavedat}/contacts/show/${this.contactId}`)
        .then(res => {
          const data = res.data.data;
          Object.keys(this.contactForm).forEach(key => {
            this.contactForm[key] = data[key];
          });
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
  watch: {
    contactId: function() {
      if (this.contactId) {
        this.getContactData();
      }
    },
  },
};
</script>

<style scoped></style>
